import React, { useState } from "react";
import { Button, Modal, Row, Col } from "reactstrap";
import "./subscribe-modal.css";
import { useNavigation } from '../../../shared/utils/useNavigation';
import { customConfirm, showError, showLoading, closeAlert } from '../../../shared/utils/swalHandler';
import { showSubscriptionCancelledPushToast } from '../../../shared/pusNotification/useManualToasts';
import { unsubscribe as unsubscribeAction } from '../../../shared/actions/subscriptionAction';
import { PURCHASE_STATE, SUBSCRIPTION_STATUS_REFRESH_DELAY_MS } from '../../../shared/constants/common';

function SubscribeModalWaitingPayment({ userInfo, handleCallback = () => {} }) {
  const navigate = useNavigation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen((prev) => !prev);
  };

  const handleToTransactions = () => {
    navigate.toTransactions();
  };

  const unSubscribe = async () => {
    const ccId = userInfo?._id;
    const username = userInfo?.username;
    if (!ccId || !username) {
      await showError(
        'Error',
        'Creator information is missing. Please refresh and try again.',
        { confirmButtonColor: '#F334BE' }
      );
      return;
    }

    const subscriptionState = userInfo?.subscription?.state;

    const confirmText = subscriptionState === PURCHASE_STATE.PENDING
      ? "Payment confirmation is in progress. Cancel anyway?"
      : "You will not be refunded and you will lose access to this account.";

    const isConfirmed = await customConfirm(
      `Unsubscribe from @${username}?`,
      confirmText,
      'Unsubscribe',
      'Cancel',
      { confirmButtonColor: '#6c757d', cancelButtonColor: '#f334be' }
    );

    if (!isConfirmed) return;

    try {
      showLoading('Cancelling subscription...');
      const result = await unsubscribeAction(ccId, subscriptionState === PURCHASE_STATE.PENDING ? true : false);

      if (result && result.success) {
        const successMessage =
          result.data?.message || 'This subscription has been successfully canceled.';
        closeAlert();
        showSubscriptionCancelledPushToast(userInfo, successMessage);
        setIsModalOpen(false);
        await new Promise((resolve) => setTimeout(resolve, SUBSCRIPTION_STATUS_REFRESH_DELAY_MS));
        await handleCallback();
      } else {
        closeAlert();
        const message = result?.error || 'Something went wrong. Please try again.';
        await showError('Error', message, { confirmButtonColor: '#F334BE' });
      }
    } catch (error) {
      closeAlert();
      await showError('Error', 'Something went wrong. Please try again.', { confirmButtonColor: '#F334BE' });
    }
  };

  return (
    <>
      {userInfo?.old_account !== true ? (
        <>
          <Button className="btn-round subscribe-btn pending_sub_btn" onClick={toggleModal}>
            Subscription pending
          </Button>

          <Modal
            isOpen={isModalOpen}
            toggle={toggleModal}
            centered
            className="subscribe-modal subs-modal logged-in"
            style={{ overflow: "hidden" }}
          >
            <Row>
              <Col className="subscribe-modal-left-side">
                <div className="modal-body d-flex flex-column justify-content-between">
                  <h4 className="text-center mt-0">Subscription Status</h4>
                  <div className="mb-4 text-center">
                    @{userInfo.username}
                  </div>
                  <Col sm="10" md="mb-5" className="mx-auto text-center">
                    <i className="fa fa-warning"></i> Subscription pending
                    <br />
                    <small>
                      * The payment will be updated automatically in few
                      minutes.
                    </small>
                  </Col>
                  <br />
                  <Col sm="10" md="mb-5" className="mx-auto ">
                    <div
                      onClick={handleToTransactions}
                      style={{ textAlign: "center" }}
                    >
                      Click to see more information
                    </div>
                  </Col>
                  <Button
                    className="btn-sm btn-link text-center text-danger"
                    onClick={unSubscribe}
                  >
                    Cancel subscription process
                  </Button>
                  <Button
                    block
                    className="btn-round py-2 my-2 mx-auto"
                    color="default"
                    onClick={toggleModal}
                    style={{ width: "100%" }}
                  >
                    Close
                  </Button>
                </div>
              </Col>
            </Row>
          </Modal>
        </>
      ) : null}
      <br />
    </>
  );
}

export default SubscribeModalWaitingPayment;
